import { SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import Flex from "./Flex";
import Text from "./Text";
import { CHART_COLORS, CHART_TYPOGRAPHY } from "./app/provider/patient/chart";

export type LabeledValueProps = {
  label: string;
  value?: ReactNode;
  /** Shown when `value` is empty. */
  emptyText?: string;
  sx?: SxProps<Theme>;
};

const DEFAULT_EMPTY_TEXT = "-";

/**
 * Read-only field with an uppercase caption above its value.
 *
 * @author Rajkumar Rathod
 */
const LabeledValue = ({
  label,
  value,
  emptyText = DEFAULT_EMPTY_TEXT,
  sx,
}: LabeledValueProps) => {
  const isEmpty = value === undefined || value === null || value === "";

  return (
    <Flex flexDirection="column" gap={0.25} sx={sx}>
      <Text
        {...CHART_TYPOGRAPHY.body5}
        c={CHART_COLORS.textMutedGrey}
        textTransform="uppercase"
        letterSpacing="0.04em"
      >
        {label}
      </Text>

      {typeof value === "string" || isEmpty ? (
        <Text {...CHART_TYPOGRAPHY.body4} c={CHART_COLORS.textDark}>
          {isEmpty ? emptyText : value}
        </Text>
      ) : (
        value
      )}
    </Flex>
  );
};

export default LabeledValue;
